(() => {
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px' }) : null;
  const reveal = (root = document) => root.querySelectorAll('.pl-reveal:not(.is-visible)').forEach((el) => (io ? io.observe(el) : el.classList.add('is-visible')));
  reveal();
  document.addEventListener('shopify:section:load', (e) => reveal(e.target));

  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    let added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); const wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
    return d;
  };
  const fillDelivery = (root = document) => root.querySelectorAll('[data-pl-delivery]:not([data-pl-done])').forEach((el) => {
    el.dataset.plDone = '1';
    const min = parseInt(el.dataset.min, 10) || 1;
    const max = parseInt(el.dataset.max, 10) || 3;
    const a = addBusinessDays(new Date(), min);
    const b = addBusinessDays(new Date(), Math.max(min, max));
    const full = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'long' });
    const short = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit' });
    const out = el.querySelector('[data-pl-delivery-text]');
    const days = parseInt(el.dataset.days, 10);
    const mid = addBusinessDays(new Date(), days > 0 ? days : Math.round((min + Math.max(min, max)) / 2));
    // Zeitleiste wie bei grossen Shops: Bestellt (heute) -> Versendet (+1 Werktag) -> Zugestellt (Ankunftsdatum)
    const dd = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
    const ship = addBusinessDays(new Date(), 1);
    const ICON = {
      order: '<path fill="currentColor" d="M6 7V6a6 6 0 0 1 12 0v1h2.2c.5 0 .9.4 1 .9l1 12.6a1.4 1.4 0 0 1-1.4 1.5H3.2a1.4 1.4 0 0 1-1.4-1.5l1-12.6c.1-.5.5-.9 1-.9zm2 0h8V6a4 4 0 0 0-8 0z"/>',
      ship: '<path fill="currentColor" d="M2 6.5A1.5 1.5 0 0 1 3.5 5h10A1.5 1.5 0 0 1 15 6.5V8h3c.5 0 .9.2 1.2.6l2.4 3.2c.2.3.4.6.4 1V16a1 1 0 0 1-1 1h-1.1a2.8 2.8 0 0 1-5.4 0H9.4a2.8 2.8 0 0 1-5.4 0H3a1 1 0 0 1-1-1zM15 10v3h5l-1.9-3zM6.7 15.4a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4zm10 0a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4z"/>',
      home: '<path fill="currentColor" d="M11.3 2.6a1 1 0 0 1 1.4 0l9 8.4a1 1 0 0 1-.7 1.7H20V20a1.5 1.5 0 0 1-1.5 1.5H15v-6h-6v6H5.5A1.5 1.5 0 0 1 4 20v-7.3H3a1 1 0 0 1-.7-1.7z"/>'
    };
    const step = (ic, lbl, d) => `<li class="pl-tl__s"><span class="pl-tl__i"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">${ICON[ic]}</svg></span><b>${lbl}</b><span>${d}</span></li>`;
    el.classList.add('pl-tl-wrap');
    // Spanne wie an der Kasse (z. B. "29.–30. Okt."), damit Produktseite, Warenkorb und Kasse dasselbe sagen
    const dm = new Intl.DateTimeFormat('de-DE', { day: 'numeric', month: 'short' });
    const arrive = el.dataset.range === '1' && max > min
      ? (a.getMonth() === b.getMonth() ? `${a.getDate()}.–${dm.format(b)}` : `${dm.format(a)} – ${dm.format(b)}`)
      : dd.format(mid);
    if (out) out.outerHTML = `<ol class="pl-tl" aria-label="Lieferzeitplan">${step('order', 'Bestellt', 'Heute')}${step('ship', 'Versendet', dd.format(ship))}${step('home', el.dataset.free === '1' ? 'Bei dir · gratis' : 'Bei dir', arrive)}</ol>`;
  });
  fillDelivery();
  if ('MutationObserver' in window) new MutationObserver(() => { if (document.querySelector('[data-pl-delivery]:not([data-pl-done])')) fillDelivery(); }).observe(document.body, { childList: true, subtree: true });

  const plMoney = (cents) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(cents / 100);
  let plProduct = null;
  const loadProduct = async () => {
    if (plProduct || !location.pathname.includes("/products/")) return plProduct;
    try { plProduct = await (await fetch(location.pathname.replace(/\/$/, "") + ".js")).json(); } catch (e) { plProduct = null; }
    return plProduct;
  };
  const decorateBundles = async () => {
    const sets = [...document.querySelectorAll("variant-selects fieldset")].filter((fs) => /paket|menge|set/i.test(fs.querySelector("legend")?.textContent || ""));
    if (!sets.length) return;
    const product = await loadProduct();
    sets.forEach((fs) => {
      fs.classList.add("pl-bundle");
      const idx = product ? product.options.findIndex((o) => /paket|menge|set/i.test(o.name || o)) : -1;
      const priceFor = (val) => {
        if (!product || idx < 0) return null;
        const vs = product.variants.filter((v) => v.options[idx] === val);
        return vs.length ? Math.min(...vs.map((v) => v.price)) : null;
      };
      const inputs = [...fs.querySelectorAll("input[type=radio]")];
      const single = inputs.map((i) => ({ n: parseInt((i.value.match(/\d+/) || ["1"])[0], 10), p: priceFor(i.value) })).find((x) => x.n === 1)?.p;
      const legend = fs.querySelector("legend");
      if (legend && !legend.dataset.pl) { legend.dataset.pl = "1"; legend.innerHTML = '<span class="pl-bundle__head">Anzahl</span>'; }
      const noun = (document.querySelector(".product__title h1")?.textContent || "Kissen").trim().replace(/^Das\s+/i, "");
      const subs = { 1: "Zum Ausprobieren", 2: "Für euch zwei", 3: "Für die ganze Familie", 4: "Für die ganze Familie" };
      const HEART = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path fill="currentColor" d="M12 21s-7.5-4.6-9.6-9.3C.9 8.2 3.1 4.5 6.8 4.5c2 0 3.5 1.1 5.2 3 1.7-1.9 3.2-3 5.2-3 3.7 0 5.9 3.7 4.4 7.2C19.5 16.4 12 21 12 21z"/></svg>';
      const TAG = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path fill="currentColor" d="M3 12.6V4.5C3 3.7 3.7 3 4.5 3h8.1c.4 0 .8.2 1.1.4l7.9 7.9c.6.6.6 1.5 0 2.1l-8.1 8.1c-.6.6-1.5.6-2.1 0l-7.9-7.9c-.3-.3-.5-.7-.5-1zM7.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/></svg>';
      const badges = { 2: "Beliebt" };
      const perPiece = (cents) => {
        const eur = Math.round(cents) / 100;
        return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", minimumFractionDigits: Number.isInteger(eur) ? 0 : 2 }).format(eur);
      };
      const cmpFor = (val) => {
        if (!product || idx < 0) return null;
        const vs = product.variants.filter((v) => v.options[idx] === val);
        if (!vs.length) return null;
        const best = vs.reduce((a, b) => (b.price < a.price ? b : a));
        return best.compare_at_price || null;
      };
      const refHtml = (n, price, val) => {
        if (price == null) return "";
        if (n === 1) {
          const cmp = cmpFor(val);
          return cmp && cmp > price ? `<s class="pl-bundle__cmp">${plMoney(cmp)}</s>` : "";
        }
        const sum = single ? single * n : 0;
        // Ersparnis gegenüber dem aktuellen Einzelpreis (kein Streichpreis-Bezug, daher PAngV-unkritisch)
        return sum > price
          ? `<small class="pl-bundle__ref">statt <s>${plMoney(sum)}</s> einzeln</small><span class="pl-bundle__save">Du sparst ${plMoney(sum - price)}</span>`
          : "";
      };
      inputs.forEach((input) => {
        const label = fs.querySelector(`label[for="${input.id}"]`);
        if (!label || label.querySelector(".pl-bundle__card")) return;
        const n = parseInt((input.value.match(/\d+/) || ["1"])[0], 10);
        const price = priceFor(input.value);
        const name = n === 1 ? "1 Kissen" : `${n} Kissen`;
        label.innerHTML = `<span class="pl-bundle__card">
          <span class="pl-bundle__dot" aria-hidden="true"></span>
          <span class="pl-bundle__txt">
            <span class="pl-bundle__line"><b>${name}</b>${badges[n] ? `<span class="pl-bundle__badge">${badges[n]}</span>` : ""}</span>
            <span class="pl-bundle__pline">${price != null ? `<b class="pl-bundle__p">${plMoney(price)}</b>` : ""}${refHtml(n, price, input.value)}</span>
          </span>
        </span><span class="visually-hidden">${input.value}</span>`;
      });
    });
  };
  decorateBundles();
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
      setTimeout(decorateBundles, 0);
      const v = ev?.data?.variant;
      document.querySelectorAll("[data-pl-satc-price]").forEach((el) => { if (v) el.textContent = plMoney(v.price); });
    });
  }
  document.addEventListener('shopify:section:load', decorateBundles);

  class PlStickyAtc extends HTMLElement {
    connectedCallback() {
      const main = document.querySelector('product-form button[type="submit"]');
      if (!main) return;
      this.hidden = false;
      const obs = new IntersectionObserver(([e]) => this.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 });
      obs.observe(main);
      this.querySelector('[data-pl-satc-buy]')?.addEventListener('click', () => {
        main.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => main.click(), 350);
      });
    }
  }
  if (!customElements.get('pl-sticky-atc')) customElements.define('pl-sticky-atc', PlStickyAtc);

  // Zusatzartikel (z. B. Wolkenbezug): passende Farbe zur gewählten Kissen-Variante vorschlagen
  const syncAddons = () => {
    document.querySelectorAll('[data-pl-addon]').forEach((el) => {
      let variants = [];
      try { variants = JSON.parse(el.querySelector('[data-pl-addon-variants]')?.textContent || '[]'); } catch (e) { variants = []; }
      if (!variants.length) return;
      const mi = parseInt(el.dataset.mainIndex, 10), ui = parseInt(el.dataset.upIndex, 10);
      let pick = variants.find((v) => String(v.id) === el.dataset.variantId) || variants.find((v) => v.available) || variants[0];
      if (mi >= 0 && ui >= 0) {
        const info = document.getElementById(`MainProduct-${el.dataset.sectionId}`);
        let sel = null;
        try { sel = JSON.parse(info?.querySelector('variant-selects [data-selected-variant]')?.textContent || 'null'); } catch (e) { sel = null; }
        const val = sel?.options?.[mi];
        const match = val && variants.find((v) => v.available && v.options[ui] === val);
        if (match) pick = match;
      }
      el.dataset.variantId = String(pick.id);
      const color = el.querySelector('[data-pl-addon-color]');
      if (color && ui >= 0) color.textContent = (color.textContent.includes('·') ? ' · ' : '') + pick.options[ui];
      const price = el.querySelector('[data-pl-addon-price]');
      if (price) price.textContent = plMoney(pick.price);
      const img = el.querySelector('.pl-addon__img img');
      if (img && pick.image) { img.src = pick.image; img.removeAttribute('srcset'); }
    });
  };
  syncAddons();
  document.addEventListener('shopify:section:load', syncAddons);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(syncAddons, 0));

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-pl-upsell]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    const drawer = document.querySelector('cart-drawer');
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.plUpsell), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.renderContents({ ...data, id: Number(btn.dataset.plUpsell) });
      } else {
        window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      }
    } catch (err) {
      btn.removeAttribute('aria-busy');
    }
  });

  // Warenkorb: Einzelkissen gegen 2er-Set derselben Farbe tauschen (nur auf Klick)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-pl-swap-key]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    const root = window.Shopify?.routes?.root || '/';
    const drawer = document.querySelector('cart-drawer');
    const id = Number(btn.dataset.plSwapVariant);
    try {
      // Ein Request: Einzelkissen raus, 2er-Set rein (kein kurzer Leer-Zustand)
      const keyRes = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: btn.dataset.plSwapKey, quantity: 0 }),
      });
      if (!keyRes.ok) throw new Error('change');
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (drawer && drawer.contains(btn) && typeof drawer.renderContents === 'function' && data.sections) {
        drawer.renderContents({ ...data, id });
        // Dawn setzt beim kurz leeren Warenkorb "is-empty" – wieder entfernen, sonst bleibt die Artikelliste unsichtbar
        drawer.classList.remove('is-empty');
        drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
      } else {
        window.location.reload();
      }
    } catch (err) {
      window.location.reload();
    }
  });

  class PlQuiz extends HTMLElement {
    connectedCallback() {
      this.steps = [...this.querySelectorAll('.pl-quiz__step')];
      this.reset();
      this.querySelector('[data-quiz-start]')?.addEventListener('click', () => this.go(1));
      this.querySelector('[data-quiz-restart]')?.addEventListener('click', () => { this.reset(); this.go(0); });
      this.querySelectorAll('.pl-quiz__answer').forEach((b) => b.addEventListener('click', () => this.answer(b)));
    }
    reset() { this.a = 0; this.b = 0; this.flags = []; this.idx = 0; }
    go(i) {
      this.idx = i;
      this.steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
      const active = this.steps[i];
      active?.querySelector('button, a')?.focus({ preventScroll: true });
    }
    answer(btn) {
      this.a += parseInt(btn.dataset.a, 10) || 0;
      this.b += parseInt(btn.dataset.b, 10) || 0;
      if (btn.dataset.flag) this.flags.push(btn.dataset.flag);
      const next = this.idx + 1;
      if (next < this.steps.length - 1) this.go(next); else this.result();
    }
    result() {
      const key = this.a > this.b ? 'a' : this.b > this.a ? 'b' : 'duo';
      this.querySelectorAll('[data-result]').forEach((r) => { r.hidden = r.dataset.result !== key; });
      const colors = { weiss: 'Wolkenweiß', gelb: 'Rosé', rose: 'Rosé', grau: 'Nebelgrau' };
      const color = this.flags.find((f) => colors[f]);
      const colorEl = this.querySelector('[data-quiz-color]');
      if (colorEl) colorEl.textContent = key === 'b' && color ? `in ${colors[color]}` : '';
      const hint = this.querySelector('[data-quiz-hint]');
      if (hint) {
        const txt = this.flags.includes('set') ? this.dataset.hintSet : this.flags.includes('gift') ? this.dataset.hintGift : '';
        hint.textContent = txt || '';
        hint.hidden = !txt;
      }
      this.go(this.steps.length - 1);
    }
  }
  if (!customElements.get('pl-quiz')) customElements.define('pl-quiz', PlQuiz);
})();

(() => {
  const COLORS = { "wolkenweiß": "#FAFAF7", "vanillegelb": "#F6E7A8", "nebelgrau": "#C9CBCF", "lavendel": "#D9CCF2", "rosé": "#F7C6D3", "rose": "#F7C6D3", "himmelblau": "#BFD9F2", "creme & rosé": "linear-gradient(135deg,#F6EFE3 50%,#F2B8C8 50%)", "creme & himmelblau": "linear-gradient(135deg,#F6EFE3 50%,#B5D3F0 50%)", "creme & salbei": "linear-gradient(135deg,#F6EFE3 50%,#C9D8C5 50%)", "blau": "#BFD9F2", "weiß": "#FAFAF7", "gelb": "#F6E7A8", "grau": "#C9CBCF" };
  const decorateSwatches = () => {
    document.querySelectorAll("variant-selects fieldset").forEach((fs) => {
      const legend = fs.querySelector("legend");
      if (!legend || !/farbe|color|colour/i.test(legend.textContent)) return;
      fs.classList.add("pl-swatches");
      fs.querySelectorAll('input[type="radio"]').forEach((input) => {
        const label = fs.querySelector(`label[for="${input.id}"]`);
        const c = COLORS[(input.value || "").toLowerCase()];
        if (label && c && !label.querySelector(".pl-sw")) { const sw = document.createElement("span"); sw.className = "pl-sw"; sw.style.setProperty("--sw", c); sw.setAttribute("aria-hidden", "true"); label.prepend(sw); }
      });
      const checked = fs.querySelector('input[type="radio"]:checked');
      let cur = legend.querySelector(".pl-swatches__current");
      if (!cur) { cur = document.createElement("span"); cur.className = "pl-swatches__current"; legend.appendChild(cur); }
      cur.textContent = checked ? `: ${checked.value}` : "";
    });
  };
  decorateSwatches();
  document.addEventListener("shopify:section:load", decorateSwatches);
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(decorateSwatches, 0));
})();
